/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefSupportReport } from '../../models/api-def-support-report';

export interface OrganizationsGetSupportReports$Params {
  organizationId: string;
  status?: string;
  createdBy?: string;
  priority?: 'low' | 'medium' | 'high';
  tags?: Array<string>;
  page?: number;
  limit?: number;
  skipCount?: boolean;
}

export function organizationsGetSupportReports(http: HttpClient, rootUrl: string, params: OrganizationsGetSupportReports$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'reports'?: Array<ApiDefSupportReport>;
'total'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetSupportReports.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.query('status', params.status, {});
    rb.query('createdBy', params.createdBy, {});
    rb.query('priority', params.priority, {});
    rb.query('tags', params.tags, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('skipCount', params.skipCount, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'reports'?: Array<ApiDefSupportReport>;
      'total'?: number;
      }>;
    })
  );
}

organizationsGetSupportReports.PATH = '/organizations/{organizationId}/support';
